import { FormModel } from 'submodules/nerit-framework-ui/common/form-state-manager/types/FormModel'
import { IsOptional } from 'class-validator'
import { IsRequired } from 'submodules/nerit-framework-utils/validators'

export class ParameterControlFiltersFormModel extends FormModel {

    @IsRequired()
    locationCodes?: number[]

    @IsOptional()
    matrixCode?: number

    @IsRequired()
    fieldCodes?: number[]

    @IsOptional()
    parameterGroupCode?: number

    @IsRequired()
    year?: number

    @IsRequired()
    month?: number

    constructor(initialData?: Partial<ParameterControlFiltersFormModel>) {
        super(initialData)
        Object.assign(this, initialData)
    }

}
